import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { CtaBand } from '@/components/generals/cta-band'
import { AboutStrip } from '@/components/landing/home/about-strip'
import { AiAdvisor } from '@/components/landing/home/ai-advisor'
import { Analytics } from '@/components/landing/home/analytics'
import { DashboardShowcase } from '@/components/landing/home/dashboard-showcase'
import { DueDiligence } from '@/components/landing/home/due-diligence'
import { Hero } from '@/components/landing/home/hero'
import { HomeFaq } from '@/components/landing/home/home-faq'
import { Testimonials } from '@/components/landing/home/testimonials'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <Hero />
            <AboutStrip />
            <Analytics />
            <AiAdvisor />
            <Testimonials />
            <DashboardShowcase />
            <DueDiligence />
            <HomeFaq />
            <CtaBand image='/images/uploads/replace-b.png' />
        </Layout>
    )
}

export default Home
